import { Check, Hourglass, type LucideIcon } from 'lucide-react';
import { Participant } from 'modules/jogador/checkout/types';
import { Skeleton } from 'shared/components/ui/Skeleton';
import { Avatar } from 'shared/components/ui/Avatar';

interface ParticipantRowProps {
  participant: Participant;
}

const STATUS_TEXT_CLASSES: Record<Participant['status'], string> = {
  paying: 'text-ink-secondary',
  paid: 'text-success',
  waiting: 'text-warning',
};

const STATUS_ICON: Record<Participant['status'], LucideIcon | null> = {
  paying: null,
  paid: Check,
  waiting: Hourglass,
};

export function ParticipantRow({ participant }: ParticipantRowProps) {
  const StatusIcon = STATUS_ICON[participant.status];

  return (
    <div className="flex items-center justify-between py-2">
      <div className="flex items-center gap-3">
        <Avatar name={participant.name} size="sm" />
        <span className="text-sm font-medium text-ink">
          {participant.name}
          {participant.isYou && ' (Você)'}
        </span>
      </div>
      <span className={`flex items-center gap-1.5 text-sm ${STATUS_TEXT_CLASSES[participant.status]}`}>
        {StatusIcon && <StatusIcon className="h-3.5 w-3.5" strokeWidth={2.5} aria-hidden="true" />}
        {participant.methodLabel}
      </span>
    </div>
  );
}

// Mesma altura de <ParticipantRow> (avatar sm + nome + status), usado enquanto a lista carrega.
export function ParticipantRowSkeleton() {
  return (
    <div aria-hidden="true" className="flex items-center justify-between py-2">
      <div className="flex items-center gap-3">
        <Skeleton className="h-8 w-8 rounded-full" />
        <Skeleton className="h-3.5 w-24" />
      </div>
      <Skeleton className="h-3.5 w-28" />
    </div>
  );
}
